import type { GrainInfoModel } from "#/modules/exam/result/services";

/**
 * The function `convertModuleInfosToStackedBarChartData` takes an array of `GrainInfoModel` items and
 * converts them into a specific format for stacked bar chart data.
 * @param {Array<GrainInfoModel> | undefined | null} items - The `items` parameter in the
 * `convertModuleInfosToStackedBarChartData` function is an array of `GrainInfoModel` objects. Each
 * `GrainInfoModel` object contains information about a particular grain, such as the grain name,
 * marks, performance label, etc. The function
 * @returns An array of objects with properties `name`, `correct`, `incorrect`, `unanswered`, and
 * `performanceLabel` is being returned.
 */
export function convertModuleInfosToStackedBarChartData(
  items: Array<GrainInfoModel> | undefined | null
) {
  if (!items || items.length === 0) return [];

  return items.map((item) => {
    const correct = Number(item.mark ?? 0);
    const markWN = Number(item.markWN ?? 0);
    const incorrectRaw = markWN - correct;
    const incorrect = incorrectRaw > 0 ? incorrectRaw : 0;

    return {
      name: item.grainName,
      correct,
      incorrect,
      unanswered: Number(item.noAnswers ?? 0),
      performanceLabel: item.performanceLabel
    };
  });
}
